import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledCurrencyWrapper = styled(FlexBox)`
    white-space: nowrap;
    max-width: 100%;
    flex-wrap: wrap;

    ${media.md(css`
        flex-wrap: nowrap;
    `)}
`;

export const StyledCurrencyValue = styled.span`
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 3px;
`;

export const StyledCurrencyLabel = styled.span`
    white-space: pre;
    flex-shrink: 0;
`;
